import React from "react";
import { FieldError, UseFormRegister } from "react-hook-form";

type RadioValue = {
  value: string | undefined;
  text: string | false | undefined;
  id?: number | string | undefined;
};

type Props = {
  name: string;
  label: string;
  valuesArr?: RadioValue[];
  register: UseFormRegister<any>;
  validation?: Record<string, any>;
  error?: FieldError;
  disabled?: boolean;
   className? : string;
};

export default function Radio({
  name,
  label,
  className,
  valuesArr,
  register,
  validation,
  error,
  disabled = false,
}: Props) {
  return (
    <div className={`text-[#1E293B] space-y-1 ${className}`}>
      {label && <label className="block text-sm w-full">{label}</label>}
      <div className="flex items-center space-x-6 py-3 flex-wrap gap-y-3">
        {valuesArr?.map((v, i) => {
          const id = `radio-${name}-${v.value}-${i}`;
          return (
            <div
              className={`flex items-center ${
                disabled ? "opacity-60" : "cursor-pointer"
              }`}
              key={id}
            >
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="radio"
                  id={id}
                  value={v.value}
                  disabled={disabled}
                  {...register(name, validation)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-[#FBD037] transition-all"
                />
                <span className="absolute bg-[#FBD037] w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
              </label>
              <label
                htmlFor={id}
                className="ml-2 text-black cursor-pointer text-sm font-medium"
              >
                {v.text}
              </label>
            </div>
          );
        })}
      </div>
      {error && <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3 ">
            {error?.message || ""}
          </span>}
    </div>
  );
}
